import { render, staticRenderFns } from "./FiksuWebLogo.vue?vue&type=template&id=65fda8f9&scoped=true&"
import script from "./FiksuWebLogo.vue?vue&type=script&lang=js&"
export * from "./FiksuWebLogo.vue?vue&type=script&lang=js&"
import style0 from "./FiksuWebLogo.vue?vue&type=style&index=0&id=65fda8f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fda8f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65fda8f9')) {
      api.createRecord('65fda8f9', component.options)
    } else {
      api.reload('65fda8f9', component.options)
    }
    module.hot.accept("./FiksuWebLogo.vue?vue&type=template&id=65fda8f9&scoped=true&", function () {
      api.rerender('65fda8f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/logo/FiksuWebLogo.vue"
export default component.exports